// adjuntosService - Sprint 44 Fase 3 Vista 10.
// Service de adjuntos para importaciones. Maneja FormData multipart.
import apiClient, { API_BASE } from '../../../api/apiClient';

const BASE = '/importaciones';

export async function listAdjuntos(importacionId) {
  const r = await apiClient.get(BASE + '/' + importacionId + '/adjuntos');
  const d = (r && r.data) || {};
  return {
    items: d.items || [],
    total: d.total || 0,
    tiposDocumento: d.tipos_documento || [],
  };
}

export async function uploadAdjunto(importacionId, { file, tipoDocumento, notas }) {
  const token = apiClient.getAccessToken();
  const fd = new FormData();
  fd.append('file', file);
  if (tipoDocumento) fd.append('tipo_documento', tipoDocumento);
  if (notas) fd.append('notas', notas);

  const res = await fetch(API_BASE + BASE + '/' + importacionId + '/adjuntos', {
    method: 'POST',
    headers: token ? { Authorization: 'Bearer ' + token } : {},
    body: fd,
  });
  let payload = null;
  try { payload = await res.json(); } catch (_) { /* ignore */ }
  if (!res.ok) {
    const err = new Error((payload && payload.message) || ('HTTP ' + res.status));
    err.status = res.status;
    err.data = payload;
    throw err;
  }
  return (payload && payload.data) || null;
}

export async function deleteAdjunto(adjuntoId) {
  return apiClient.delete(BASE + '/adjuntos/' + adjuntoId);
}

export function adjuntoHref(urlArchivo) {
  if (!urlArchivo) return '#';
  if (/^https?:\/\//i.test(urlArchivo)) return urlArchivo;
  const origin = (API_BASE || '').replace(/\/api\/?$/, '');
  return origin + urlArchivo;
}
